import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_GIVEN_CANS } from "../given-cans.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateGivenCansInput } from "../../../__generated__/globalTypes";
import {
  UpdateGivenCansMutation,
  UpdateGivenCansMutationVariables,
} from "../../../__generated__/UpdateGivenCansMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateGivenCans = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateGivenCansInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateGivenCansMutation,
    UpdateGivenCansMutationVariables
  >(UPDATE_GIVEN_CANS, {
    refetchQueries: "active",
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateGivenCans?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateGivenCans?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
